const electricUtilities = {
  AK: [
    'Alaska Villages Electric Cooperative',
    'Chugach Electric Association',
    'Copper Valley Electric Association',
    'Golden Valley Electric Association',
    'Kodiak Electric Association',
    'Municipal Light & Power',
    'Not Listed',
  ],
  IN: [
    'American Electric Power',
    'Duke Energy Indiana',
    'Indianapolis Power & Light',
    'Northern Indiana Public Service Company',
    'Not Listed',
  ],
  KY: [
    'American Electric Power',
    'Big Rivers Electric Corporation',
    'Duke Energy Kentucky',
    'Fleming-Mason Energy Cooperative',
    'Henderson Municipal Power and Light',
    'Kenergy Corp',
    'Kentucky Utilities',
    'Louisville Gas & Electric',
    'Owensboro Municipal Utilities',
    'Salt River Electric',
    'Tennessee Valley Authority',
    'Pennyrile Rural Electric Co-Op',
    'Not Listed',
  ],
  LA: ['CLECO', 'Entergy', 'SLECMO', 'SWEPCO', 'Not Listed'],
  ME: [
    'Bangor Hydro Electric',
    'Central Maine Power',
    'Eastern Maine Electric Coop',
    'Not Listed',
  ],
  MS: [
    'Entergy',
    'Magnolia Electric',
    'Mississippi Power Company',
    'Southwest Mississippi Electric Power Association',
    'Tennessee Valley Authority',
    'Not Listed',
  ],
  MT: [
    'Central Montana Electric Power Cooperative',
    'MDU',
    'Montana Electric Cooperatives Association',
    'Northwestern Energy',
    'Not Listed',
  ],
  ND: [
    'Basin Electric Power Cooperative',
    'Central Power Electric Cooperative',
    'MDU',
    'Minnkota Power Cooperative',
    'Otter Tail Power Company',
    'Upper Missouri G&T Cooperative',
    'Xcel Energy',
    'Not Listed',
  ],
  NE: [
    'Nebraska Public Power District',
    'Omaha Public Power District',
    'CL&P',
    'Eversource',
    'Not Listed',
  ],
  SD: [
    'Black Hills Power',
    'East River Electric Cooperative',
    'Montana-Dakota Utilities',
    'Northwestern Energy',
    'Otter Tail Power Company',
    'Rushmore Electric Cooperative',
    'Xcel Energy',
    'Not Listed',
  ],
  WA: [
    'Avista Utilities',
    'Benton PUD',
    'Chelan County Public Utility District',
    'Columbia REA',
    'Douglas County Public Utility District',
    'Grant County Public Utility District',
    'Klickitat Public Utility District',
    'Mason County Public Utility District 3',
    'PacifiCorp (Pacific Power)',
    'Puget Sound Energy',
    'Seattle City Light',
    'Snohomish County Public Utility District (PUD)',
    'Tacoma Power',
    'Not Listed',
  ],
  WV: [
    'Allegheny Power',
    'Appalachian Power',
    'Wheeling Electric Power (AEP Ohio)',
    'Not Listed',
  ],
  WY: ['Cheyenne Light, Fuel & Power', 'High Plains Power', 'Not Listed'],
  RI: [
    'National Grid - Rhode Island',
    '----------',
    'National Grid - Rhode Island',
    'Ambit Energy',
    'Block Island Power Co',
    'Cleaview Energy',
    'First Point Power (FPP)',
    'Zelienople',
    'Pascoag Utility District (PUD)',
    'Narragansett Electric Co',
    'Not Listed',
  ],
  NH: [
    'Eversource Energy (Public Service-NH)',
    'Unitil Corporation',
    '----------',
    'Granite State Electric',
    'National Grid',
    'Eversource Energy (Public Service-NH)',
    'Ambit Energy',
    'KSEB',
    'New Hampshire Electric Coop (NHEC)',
    'North American Power',
    'ENH Power',
    'FairPoint Energy',
    'A & N Electric Coop (ANEC)',
    'Unitil Corporation',
    'Ashland Electric',
    'Public Service of NH',
    'Not Listed',
  ],
  VT: [
    'Green Mountain Power',
    'Burlington Electric Department',
    '----------',
    'Green Mountain Power',
    'Vermont Electric COOP',
    'Washington Electric',
    'Burlington Electric Department',
    'VELCO - Vermont Electric Power Company',
    'Hyde Park Electric Department',
    'Johnson Water & Light Department',
    'Stowe Electric',
    'Xoom Energy',
    'Barton Village',
    'Enosburg Falls Water & Light Dept',
    'Morrisville Water & Light Dept',
    'Not Listed',
  ],
  DE: [
    'City of Dover Electric Department',
    'Delaware Electric Cooperative',
    'Delmarva Power',
    '----------',
    'City of Dover Electric Department',
    'City of Milford',
    'Delaware Electric Cooperative',
    'Delmarva Power',
    'NRG Energy',
    'City of Lewes',
    'Town of Middletown',
    'Town of Smyrna',
    'Clearview Energy',
    'Ambit Energy',
    'Commerce Energy',
    'Starion Energy',
    'PEPCO',
    'Town of Clayton',
    'City of Seaford',
    'City of Newark',
    'Just Energy',
    'Washington Gas Energy Services (WGES)',
    'Direct Energy',
    'New Castle Municipal Services',
    'Not Listed',
  ],
  DC: ['PEPCO', '----------', 'PEPCO', 'Ambit Energy', 'Not Listed'],
  NM: [
    'PNM - Public Service Company of New Mexico',
    'El Paso Electric Company (New Mexico)',
    '----------',
    'Farmington Electric Utility System',
    'PNM - Public Service Company of New Mexico',
    'El Paso Electric Company (New Mexico)',
    'Columbus Electric Coop',
    'Continental Divide Electric Coop (CDEC)',
    'Farmers Electric Coop',
    'Jemez Mountains Electric Coop',
    'Kit Carson Electric Coop (KCEC)',
    'Lea County Electric Coop',
    'Los Alamos County',
    'Mora-San Miguel Electric Coop',
    'Navajo Tribal Utility Authority (NTUA)',
    'Northern Rio Arriba Electric Coop (NORA)',
    'Otero County Electric Coop',
    'Raton Public Service Co',
    'Roosevelt County Electric Coop',
    'Sierra Electric Coop',
    'Socorro Electric Coop',
    'Southwestern Electric Coop',
    'Springer Electric Coop',
    'Tri-County Electric Coop (TCEC)',
    'Truth of Consequences',
    'Xcel Energy',
    'Not Listed',
  ],
  MN: [
    'Alliant Energy',
    'Basin Electric Power Cooperative',
    'East River Electric Power Co-op',
    'Great River Energy',
    'Hutchinson Utilities Commission',
    'ITC Midwest',
    'L&O Power Co-op',
    'Lake Country Power',
    'Marshall Municipal Utilities',
    'Minnesota Power',
    'Minnkota Power Cooperative',
    'Missouri River Energy Services',
    'Otter Tail Power Company',
    'People',
    'Rochester Public Utilities',
    'Tri-County Electric',
    'Xcel Energy',
    'Minnesota Valley Electric Cooperative',
    'Connexus',
    'Goodhue County Cooperative Electric',
    'Worthington Public Utilities',
    'Glencoe Light & Power',
    'Dakota Electric',
    'Peoples Coop Power',
    'Allete',
    'Todd-Wadena Cooperative Electric',
    'Traverse Electric Coop',
    'Red Lake Electric Cooperative',
    'East Central Energy',
    'Lake Region Electric Cooperative',
    'Wright Hennepin Electric Cooperative',
    'Kasota Electric Dept',
    'Brown County Rural Electric',
    'East Central Electric Association',
    'Ada Water & Light',
    'Sleepy Eye Public',
    'McLeod Cooperative Power',
    'Ely Utilities',
    'Benco Electric Cooperative',
    'City of Rushford',
    'Crow Wing Coop Power & Light',
    'Shakopee Public Utilities',
    'Roseau Electric Cooperative',
    'City of North Saint Paul',
    'Kandiyohi Cooperative Electric',
    'Anoka Municipal Utility',
    'City of Chaska Electric Department',
    'Crow Wing Cooperative Power & Light Company',
    'Runestone Electric Association',
    'Tri County Electric Cooperative',
    'Goodhue County Cooperative Electric Association',
    'Alexandria Light & power',
    'Minnesota Valley Electric Coop',
    'Northern States Power Co',
    'Not Listed',
  ],
  MD: [
    'Allegheny Power (Potomac Edison)',
    'BGE - Baltimore Gas & Electric',
    'Choptank Electric Cooperative',
    'Delmarva Power',
    'PEPCO',
    '----------',
    'Allegheny Power (Potomac Edison)',
    'BGE - Baltimore Gas & Electric',
    'Choptank Electric Cooperative',
    'Delmarva Power',
    'Southern Maryland Electric Co-op',
    'PEPCO',
    'Easton Utilities',
    'Ambit Energy',
    'Constellation',
    'MDG&E - Maryland Gas & Electric',
    'Public Power & Utility of MD',
    'Stream Energy',
    'Town of Berlin',
    'City of Hagerstown',
    'Starion Energy',
    'Direct Energy',
    'Champion Energy',
    'NRG Home',
    'Somerset REC',
    'Commerce Energy',
    'Thurmont Municipal Light Co',
    'Washington Gas Energy Services (WGES)',
    'Green Mountain Energy',
    'Xoom Energy',
    'North American Power',
    'SMECO',
    'SMECO',
    'Not Listed',
  ],
  OH: [
    'American Electric Power',
    'Cincinnati Bell Energy',
    'Cleveland Electric Illuminating Company',
    'Consolidated Electric Cooperative',
    'Dayton Power & Light',
    'Duke Energy Ohio',
    'FirstEnergy',
    'Ohio Edison',
    'South Central Power Company',
    'Toledo Edison',
    'Starion Energy',
    'Ohio Power',
    'Frontier Power Co',
    'IGS Energy',
    'Not Listed',
  ],
  WI: [
    'Alliant Energy',
    'Dairyland Power Co-op',
    'Madison Gas and Electric',
    'We Energies',
    'Wisconsin Power and Light Company',
    'Wisconsin Public Service Corporation',
    'Xcel Energy',
    'Dunn Energy Coop',
    'Pierce-Pepin Coop',
    'New Richmond',
    'Oakdale Electric Coop',
    'River Falls',
    'Riverland Energy Cooperative',
    'Not Listed',
  ],
  MI: [
    'Indiana Michigan Power',
    'Consumers Energy',
    'DTE Energy (Detroit Edison)',
    'Excel Energy',
    'Holland Board of Public Works',
    'Lansing Board of Water & Light',
    'Upper Peninsula Power Company',
    'Upper Michigan Energy Resources Corp. (UMERC) (We Energies)',
    'Wyandotte Municipal Services',
    'Tri-County Electric',
    'Not Listed',
  ],
  UT: [
    'Brigham City Public Power',
    'Intermountain Power Agency',
    'Kaysville City',
    'PacifiCorp (Rocky Mountain Power)',
    'Provo City Power',
    'Springville City',
    'Spanish Fork',
    'Murray City Power',
    'Logan City Light and Power',
    'Lehi City Power',
    'Salem City Power',
    'Payson City Power',
    'Garkane Energy',
    'Bountiful City Light and Power',
    'Nephi City',
    'Dixie Power',
    'Not Listed',
  ],
  CA: [
    'LADWP - Los Angeles Department of Water & Power',
    'PG&E - Pacific Gas & Electric',
    'SMUD - Sacramento Municipal Utility District',
    'SDG&E - San Diego Gas & Electric',
    'SCE - Southern California Edison',
    '----------',
    'Alameda Municipal Power',
    'APU - Anaheim Public Utilities',
    'Azusa Light & Water',
    'Bear Valley Electric',
    'Burbank Water & Power',
    'City & County of San Francisco',
    'City of Palo Alto Utilities',
    'Colton Public Utilities',
    'Gridley Municipal Utilities',
    'Healdsburg Municipal Electric Department',
    'IID - Imperial Irrigation District',
    'Lodi Electric Utility',
    'LADWP - Los Angeles Department of Water & Power',
    'Modesto Irrigation District',
    'PacifiCorp',
    'PG&E - Pacific Gas & Electric',
    'Pasadena Water & Power',
    'Riverside Public Utilities',
    'SMUD - Sacramento Municipal Utility District',
    'SDG&E - San Diego Gas & Electric',
    'Silicon Valley Power',
    'SCE - Southern California Edison',
    'Southern California Public Power Authority',
    'Surprise Valley Power',
    'Trinity PUD',
    'City of Vernon Gas & Electric Department',
    'City of Redding Electric Utility',
    'Roseville Electric Department',
    'Marin Clean Energy',
    'Island Energy',
    'Moreno Valley Electrical Utility',
    'Glendale Water & Power',
    'Anza Electric Co-Op',
    'Lassen Municipal Utility District',
    'Plumas-Sierra Rural Electric Cooperative',
    'Liberty Utilities',
    'City of Turlock',
    'Ukiah Municipal Utility District',
    'Truckee-Donner Public Utilities District',
    'Mountain Utilities',
    'Merced Irrigation District',
    'Biggs Electrical Department',
    'Banning Electric Department',
    'Santa Maria Energy',
    'Lompoc',
    'Tuolumne Utility District (TUD)',
    'Turlock Irrigation District (TID)',
    'Xoom Energy',
    'Rancho Cucamonga',
    'Delano',
    'Kirkwood Meadows PUD',
    'Needles (NPUA)',
    'Corona',
    'Shasta Lake',
    'Sonoma Clean Power',
    'Intermountain Power Agency',
    'Ambit Energy',
    'California Bureau of Reclamation',
    'California Municipal Utilities',
    'California Public Utilities Commission',
    'Central California Power Agency',
    'Long Beach Gas and Oil',
    'Not Listed',
  ],
  HI: [
    'HECO - Hawaiian Electric Company',
    'HELCO - Hawaii Electric Light Company',
    '----------',
    'HECO - Hawaiian Electric Company',
    'KIUC - Kauai Island Utility Co-op',
    'MECO - Maui Electric Co',
    'HELCO - Hawaii Electric Light Company',
    'Not Listed',
  ],
  MA: [
    'National Grid USA',
    'UNITIL',
    'Eversource Energy',
    'WMECO ',
    '----------',
    'Braintree Electric Light Department',
    'Holden Municipal Light Department ',
    'MMWEC - Massachusetts Municipal Wholesale Electric Company',
    'National Grid USA',
    'PMLP - Peabody Municipal Light Plant',
    'Wakefield Municipal Gas and Light Department',
    'UNITIL',
    'Eversource Energy',
    'Town of Mansfield',
    'City of Taunton',
    'Belmont Municipal Light Department',
    'Reading Municipal Light Department',
    'Concord Municipal Light Plant',
    'North Attleborough Electric Department',
    'Starion Energy',
    'Holyoke Gas & Electric Department',
    'Direct Energy',
    'Templeton Municipal Light and Water Plant',
    'Sterling Municipal Light Department',
    'Ambit Energy',
    'Norwood',
    'Chicopee Electric Light Department (CELD)',
    'Paxton',
    'Shrewsbury Electric (SELCO)',
    'Middleborough Gas & Electric (MGED)',
    'Middleton Electric Light Department (MELD)',
    'South Hadley Electric Light Department (SHELD)',
    'Verde Energy',
    'Viridian Energy',
    'Wellesley',
    'West Boylston (WBMLP)',
    'Westfield Gas + Electric (WG+E)',
    'Hudson Light and Power',
    'Hull Municipal Light Plant',
    'Just Energy',
    'Liberty Power',
    'Littleton Electric Light Department (LELD)',
    'Ashburnham Municipal Light Plant',
    'Chester Municipal Electric Light Dept',
    'Danvers Electric Department',
    'Georgetown Electric',
    'Groveland Municipal Light Dept',
    'Hingham Municipal Light Plant',
    'Merrimac Municipal Light Department',
    'WMECO ',
    'Boylston Municipal',
    'Gosnold Electric',
    'Hingman Municipal',
    'Ipswich Municipal',
    'Marblehead Municipal',
    'Princeton Municipal',
    'Quincy Utility',
    'Rowley Municipal',
    'Russel Municipal',
    'NSTAR Electric Company',
    'Not Listed',
  ],
  NJ: [
    'ACE - Atlantic City Electric (Conectiv) ',
    'REC - Rockland Electric Co (Orange & Rockland)',
    'PSE&G- Public Service Electric & Gas Co.',
    'JCP&L - Jersey Central Power & Light',
    '----------',
    'ACE - Atlantic City Electric (Conectiv) ',
    'JCP&L - Jersey Central Power & Light',
    'REC - Rockland Electric Co (Orange & Rockland)',
    'PSE&G- Public Service Electric & Gas Co.',
    'SREC - Sussex Rural Electric Cooperative',
    'Vineland Municipal Electric Utility',
    'Ambit Energy',
    'Champion Energy',
    'Direct Energy',
    'IDT Energy, Inc.',
    'Constellation',
    'Liberty Power',
    'Verde Energy',
    'Starion Energy',
    'Madison Electric Department',
    'FairPoint Energy',
    'New Jersey Gas & Electric (NJG&E)',
    'Gateway Energy Services Corp (GESC)',
    'DSP Energy',
    'Pepco',
    'Eversource (Northeast Utilities)',
    'Vineland Municipal Utilities',
    'Milltown Boro',
    'South River',
    'JCP&L - Jersey Central Power & Light',
    'Not Listed',
  ],
  ID: [
    'Idaho Power',
    '----------',
    'Clearwater Power',
    'IDACORP',
    'Idaho Power',
    'PacifiCorp (Rocky Mountain Power)',
    'Fall River Electric',
    'Idaho Falls Power',
    'Not Listed',
  ],
  OR: [
    'PacifiCorp (Pacific Power)',
    'Portland General Electric',
    '----------',
    'Ashland Electric',
    'Canby Electric',
    'Columbia River Public Utility District',
    'Emerald PUD',
    'Eugene Water & Electric Board',
    'Idaho Power',
    'PacifiCorp (Pacific Power)',
    'Portland General Electric',
    'Salem Electric',
    'Tillamook PUD',
    'Wasco Electric',
    'West Oregon Electric Cooperative',
    'City of McMinnville',
    'Coos Curry Electric Coop',
    'Columbia River PUD',
    'Central Lincoln PUD',
    'Lane Electric',
    'Springfield Utility Board',
    'Arcadia Power Oregon',
    'Seaside Power Oregon',
    'Not Listed',
  ],
  AZ: [
    'APS - Arizona Public Service Co.',
    '----------',
    'APS - Arizona Public Service Co.',
    'City of Safford Electric Department ',
    'MEC - Mohave Electric Co-op',
    'SRP - Salt River Project',
    'Sulphur Springs Valley Electric Coop',
    'TEP - Tucson Electric Power',
    'UniSource Energy Services',
    'Trico Electric Cooperative',
    'Hohokam Irrigation & Drainage District',
    'City of Mesa Utilities',
    'Electrical District #2',
    'Electrical District #3',
    'Buckeye Water C&D District',
    'Dixie Power',
    'Duncan Valley Electric Coop',
    'Electrical District No 4',
    'Electrical District No 5',
    'Electrical District No 6',
    'Electrical District No 7',
    'Electrical District No 8',
    'Garkane Energy',
    'Gila River (GRICUA)',
    'Graham County Electric Coop',
    'Morenci',
    'Navajo Tribal Utility Authority (NTUA)',
    'Navopache Electric Coop',
    'Page Electric Utility',
    'San Carlos Project',
    'Thatcher',
    "Tohono O'Odham Utility Authority",
    'Wellton-Mohawk',
    'Wickenburg',
    'Not Listed',
  ],
  IA: [
    'Interstate Power and Light Company',
    'MidAmerican Energy',
    'North West REC',
    'Mora Municipal Utilities',
    'Rochester Public Utlities',
    'Alamakee-Clayton Elec Cooperative',
    'Iowa Lakes REC',
    'Prairie Energy Cooperative',
    'Midland Power Cooperative',
    'Wilton Municipal',
    'Hawkeye REC',
    'Farmers Electric Coop',
    'Linn County Rural Electric Coop',
    'Forest City Municipal',
    'Long Grove Municipal Electric',
    'Eastern Iowa Light & Power Coop',
    'Alliant Energy',
    'Access Energy Coop',
    'Allamakee Clayton Electric Coop',
    'Amana Society Service',
    'Chariton Valley Electric Coop',
    'Clarke Electric Coop',
    'Franklin Rural Electric Coop',
    'Grundy Electric Coop',
    'Heartland Power Coop',
    'Maquoketa Valley Electric Coop',
    'MiEnergy Coop',
    'Southwest Iowa Rural Electric Coop',
    'TIP Rural Electric Coop',
    'Tipton Municipal',
    'Not Listed',
  ],
  MO: [
    'Ameren',
    'City Utilities of Springfield',
    'Coast Electric',
    'Empire District Electric Company',
    'Howard Electric Cooperative',
    'Independence Power and Light',
    'Kansas City Power & Light',
    'New-Mac Electric',
    'Boone Electric Coop',
    'Not Listed',
  ],
  KS: [
    'Kansas City Board of Public Utilities',
    'Kansas City Power & Light',
    'Westar Energy',
    'Evergy',
    'City of Oxford Electric',
    'City of Augusta Electric',
    'Not Listed',
  ],
  OK: [
    'American Electric Power',
    'Oklahoma Gas & Electric',
    'Public Service Company of Oklahoma',
    'Skiatook Municipal',
    'Wagoner Electric',
    'Cookson Hills Electric Co-op',
    'Kiamichi Electric Co-op',
    'Peoples Electric Co-op',
    'Kay Electric',
    'Sallisaw Municipalities',
    'Collinsville Energy',
    'Not Listed',
  ],
  TN: [
    'Citizens Utilities Board',
    'Electric Power Board',
    'Jackson',
    'Kingsport Power (Appalachian Power)',
    'Knoxville Utilities Board',
    'Lenoir City Utilities Board',
    'Memphis Light, Gas and Water',
    'Nashville Electric Service',
    'Tennessee Jackson Energy Authority',
    'Tennessee Valley Authority',
    'Weakley County Municipal Electric System',
    'Holly Spring Utilities',
    'Not Listed',
  ],
  VA: [
    'Allegheny Power',
    'Appalachian Power',
    'Danville Utilities',
    'Delmarva Power',
    'Dominion Virginia Power',
    'NOVEC',
    'Northern Neck Electric Cooperative',
    'Rappahannock Electric Cooperative',
    'Shenandoah Valley Electric Cooperative',
    'Town of Culpeper Electric',
    'Not Listed',
  ],
  SC: [
    'Duke Energy Carolinas',
    'Progress Energy Carolinas',
    'South Carolina Electric & Gas Company',
    'Laurens Electric Cooperative',
    '----------',
    'Berkeley Electric Cooperative',
    'Central Electric Power Cooperative, Inc.',
    'Duke Energy Carolinas',
    'Progress Energy Carolinas',
    'Santee Cooper',
    'South Carolina Electric & Gas Company',
    'Santee Electric Cooperative',
    'Clinton Utilities',
    'Abbeville Public Utilities',
    'Easley Utilities',
    'Gaffney',
    'Greer Commission of Public Works',
    'Laurens Electric Cooperative',
    'Newberry',
    'Rock Hill',
    'Union',
    'Westminster',
    'Aiken Electric',
    'Heath Springs Light and Power',
    'Edisto Electric Cooperative',
    'York Electric Cooperative',
    'Lockhart Power ',
    'Mid Carolina Electric Coop ',
    'Broad River Electric Coop',
    'Little River',
    'Fairfield Electric Coop',
    'PDEC - Pee Dee Electric Coop',
    'Tri-Country Electric Coop',
    'Blue Ridge Electric Coop',
    'Coastal Electric Coop',
    'Seneca',
    'Orangeburg',
    'Marlboro',
    'Horry Electric',
    'Lynches River Electric',
    'Black River Electric',
    'Palmetto Electric',
    'City of Georgetown',
    'Winnesboro',
    'CPW',
    'Not Listed',
  ],
  AL: [
    'AECO (Alabama Electric Company)',
    'Alabama Power',
    'PowerSouth Energy Cooperative, Inc.',
    'Tennessee Valley Authority',
    'Wiregrass Electric Cooperative',
    'City of Bessmer Electric and Water Service',
    'Not Listed',
  ],
  AR: [
    'Entergy',
    'First Electric Cooperative',
    'North Little Rock Electric',
    'Augusta Municipality',
    'Arkansas Valley Electric Cooperative',
    'Not Listed',
  ],
  CO: [
    'Black Hills Energy',
    'Colorado Springs Utilities',
    'Holy Cross Energy Company',
    'Intermountain Rural Electric Association',
    'United Power Inc',
    'Xcel Energy',
    'Island Energy',
    'Fort Collins Utilities',
    'Morgan County Rural Electric Association',
    'Poudre Valley Rural Electric Association Inc',
    'Mountain View Electric Association Inc',
    'City of Longmont',
    'Fountain Electric',
    'Loveland Utilities',
    'Boone REMC',
    'Mountain Parks Electric',
    'IREA',
    'Gunnison County Electric Company',
    'La Plata Electric Association',
    'Not Listed',
  ],
  CT: [
    'United Illuminating Company',
    'Eversource',
    '----------',
    'United Illuminating Company',
    'Wallingford Electric',
    'CL&P',
    'Connecticut Gas & Electric',
    'Spark Energy',
    'Verde Energy USA',
    'Connecticut Municipal Electric',
    'Abest Power & Gas',
    'Groton Utilities',
    'Jewett City',
    'North American Power',
    'Norwalk Third Taxing District',
    'Norwich Public Utilities (NPU)',
    'Public Power',
    'South Norwalk',
    'Starion Energy',
    'Town Square Energy',
    'Constellation Energy',
    'Viridian Energy',
    'Discount Power',
    'Bozrah Light & Power',
    'Consolidated Edison-NY (ConEd)',
    'Direct Energy',
    'Ambit Energy',
    'Eversource',
    'CT-PSEG Long Island',
    'Norwalk Third Taxing District',
    'Not Listed',
  ],
  FL: [
    'City of Tallahassee Utilities',
    'City of Vero Beach',
    'Duke Energy',
    'Florida Municipal Power Agency',
    'Florida Power & Light',
    'Florida Public Utility Company Palm Beach',
    'Gainesville Regional Utilities',
    'Gulf Power',
    'JEA',
    'Kissimmee Utility Authority',
    'LCEC',
    'Lake Worth Utilities',
    'Lakeland Electric',
    'Ocala Electric',
    'OUC - Orlando Utilities Commission',
    'Progress Energy Florida',
    'TECO',
    'Withlacoochee River Electric Cooperative',
    'Central Florida Electric Cooperative',
    'City of Ocala utilities',
    'Peace River Electric',
    'Homestead Electric',
    'City of Wauchula Electric',
    'Florida Keys Electric Cooperative',
    'SECO',
    'Glades Electric',
    'CHELCO',
    'Clay Electric',
    'Bartow',
    'Baugh Southeast Co-Op',
    'Beaches Energy Services',
    'Choctawhatchee Electric Co-Op',
    'City of Clewiston',
    'City of Green Cove Springs',
    'City of Leesburg',
    'City of New Smyrna Beach',
    'City of Starke',
    'City of Fort Meade',
    'Florida Public Utility Company Palm Beach',
    'Fort Pierce Utilities Authority',
    'Suwannee Valley Elec Coop Inc',
    'Talquin Electric Coopeartive',
    'Tri-County Electric Coop',
    'West Florida Electric Cooperative',
    'Not Listed',
  ],
  GA: [
    'Flint Energies',
    'Georgia EMC',
    'Georgia Power',
    'Tennessee Valley Authority',
    'Charles E Hill Electric Co',
    'Okefenokee Rural Electric (OREMC)',
    'XOOM Energy',
    'Not Listed',
  ],
  IL: [
    'ComEd Electric Company',
    '----------',
    'Ameren',
    'Batavia Municipal Electric',
    'ComEd Electric Company',
    'Springfield City Water, Light & Power',
    'Tara Energy',
    'Starion Energy',
    'Naperville Public Utilities',
    'Jo-Carrol Energy',
    'McDonough Power Coop',
    'Menard Electric Coop',
    'Rock Falls Municipal',
    'Western Illinois Electric Coop',
    'City of Princeton Electric',
    'Not Listed',
  ],
  NC: [
    'Duke Energy NC',
    'Progress Energy Carolinas',
    '----------',
    'Blue Ridge Electrical Membership Corp.',
    'Duke Energy NC',
    'Halifax Electric Membership',
    'Haywood EMC',
    'PWC Fayetteville',
    'Progress Energy Carolinas',
    'Wake Electric',
    'Wake Forest Power',
    'Union Power Coop',
    'Energy United',
    'Tri City Electric',
    'High Point',
    'Concord Electric',
    'Kingston',
    'Lumbee River EMC',
    'Town of Louisburg',
    'Tideland EMC',
    'Rocky Mount Public',
    'Town of Benson',
    'Albemarle EMC',
    'Four County EMC',
    'Randolph EMC',
    'Town of Farmville',
    'Dominion Energy',
    'United Cooperative Services',
    'Not Listed',
  ],
  NV: [
    'NV Energy',
    '----------',
    'NV Energy',
    'Nevada Power',
    'Sierra Pacific Power',
    'Overton Power District No 5',
    'Lincoln County Power District Number 1',
    'Not Listed',
  ],
  NY: [
    'Consolidated Edison Company of New York (Con Edison)',
    'New York State Electric & Gas (NYSEG)',
    'Orange and Rockland (NY)',
    'Central Hudson Gas & Electric',
    'PSE&G Long Island',
    'National Grid (Niagara Mohawk)',
    '----------',
    'CH Energy Group',
    'Citizens Choice Energy Jamestown BPU',
    'Consolidated Edison Company of New York (Con Edison)',
    'Green Island Power Authority',
    'Long Island Power Authority (LIPA)',
    'New York Power Authority (NYPA)',
    'New York State Electric & Gas (NYSEG)',
    'Orange and Rockland (NY)',
    'RG&E Rochester Gas & Electric',
    'Central Hudson Gas & Electric',
    'PSE&G Long Island',
    'SREC -Sussex Rural Electric Cooperative',
    'Marathon Energy',
    'Think Energy',
    'Starion Energy',
    'Oasis Energy',
    'National Grid (Niagara Mohawk)',
    'BlueRock Energy Inc.',
    'Direct Energy',
    'Reliant Energy',
    'Fishers Island Utility Co',
    'Energy Coop of New York',
    'Fairport Electric',
    'Ambit Energy',
    'Champion Energy',
    'Energetix',
    'Ethical Electric',
    'Endicott',
    'Eastern Maine Electric Coop',
    'Bath Electric Gas & Water (BEGWS)',
    'Calpine Power America',
    'Freeport Electric',
    'Spencerport Municipal Electric (SME)',
    'Delaware County Electric Coop',
    'Otsego Electric Coop',
    'Oneida-Madison Electric Coop',
    'NRG Home',
    'New York Gas & Electric (NYG&E)',
    'Jamestown Board of Public Utilities (BPU)',
    'Green Mountain Energy',
    'Kiwi Energy',
    'Bounce Energy',
    'IGS Energy',
    'IDT Energy',
    'Gateway Energy Services Corp (GESC)',
    'Agway Energy Services',
    'Xcel Energy',
    'Steuben REC',
    'Abest Power & Gas',
    'Albany Water Gas and Light Commission',
    'NY-PECO Energy Co',
    'Plattsburgh Municipal Lighting Department',
    'Rockville Centre NY (Village of)',
    'Not Listed',
  ],
  PA: [
    'PECO',
    'PPL Electric Utilities',
    'Duquesne Light',
    'Met-Ed (FirstEnergy)',
    '----------',
    'Citizens Electric of Lewisburg',
    'Starion Energy',
    'PECO',
    'PPL Electric Utilities',
    'Penelec - First Energy Corp.',
    'Penn Power - First Energy Corp.',
    'PCL&P - Pike County Light & Power Company',
    'Rural Valley Electric Co.',
    'UGI Utilities, Inc.',
    'Wellsboro Electric Company',
    'West Penn Power',
    'Duquesne Light',
    'Met-Ed (FirstEnergy)',
    'FirstEnergy (Allegheny)',
    'CPL Retail Energy',
    'Adams Electric Coop',
    'Fort Pierce',
    'Bounce Energy',
    'Tri-County REC',
    'Not Listed',
  ],
  TX: [
    'Ambit Energy',
    'AEP - American Electric Power',
    'Amigo Energy',
    'Austin Energy',
    'Bounce Energy',
    'CPS Energy',
    'CenterPoint Energy',
    'Champion Energy Services',
    'Coserv Electric',
    'Denton Municipal Electric',
    'Direct Energy',
    'Entergy',
    'Entrust Energy',
    'First Texas Energy Corporation',
    'GVEC',
    'Garland Power and Light',
    'Georgetown Utility Services (GUS)',
    'Gexa Energy',
    'Green Mountain Energy',
    'Just Energy',
    'Lower Colorado River Authority',
    'Luminant',
    'Magic Valley Electric Coop',
    'Oncor Electric (Formerly TXU)',
    'Pedernales Electric Cooperative',
    'Pennywise Power',
    'Reliant Energy',
    'SWEPCO - Southwestern Electric Power Company',
    'Star Tex Power',
    'Stream Energy',
    'Summer Energy',
    'Tara Energy',
    'Tri Eagle Energy',
    'United Cooperative Services',
    'TruSmart Energy',
    'First Choice Power (Texas-New Mexico Power Company)',
    'Cooke County Electric Cooperative',
    'Fannin County Electric Cooperative',
    'HILCO Electric Cooperative, Inc.',
    'El Paso Electric Company (Texas)',
    'MP2 Energy',
    'Oncor',
    'Rio Grande Electric Coop Inc',
    'San Bernard Electric Cooperative',
    'Sam Houston Electric',
    'PEC',
    'Coserv',
    'Cirro Energy',
    'IGS Energy',
    'CPL Energy',
    'Bandera Electric Coop',
    'Blue Bonnet Electric Coop',
    'New Braunfels Utilities',
    'Farmers Electric',
    'Trinity Valley Electric Co-op',
    'City of College Station Utilities',
    'BTU (Bryan Texas Utility)',
    'Tri-County Electric Corp.',
    'City of Sanger',
    'Grayson Collin Electric Co.',
    'FELPS - Floresville Elec. Light & Power',
    'Deep East Texas Electric',
    'Medina Valley Electric',
    'Robstown Co-Op',
    'Heart of Texas',
    'Lamar County Co-Op',
    'Cherokee',
    'City of Houston',
    'Bartlett Electric Coop, Inc',
    'Brilliant Energy',
    'Central Texas Electric Co-Op',
    'City of San Antonio',
    'City of Seguin',
    'City Public Service',
    'Coleman County Elec Coop Inc',
    'Comanche Electric Cooperative',
    'Concho Valley Elec Coop Inc',
    'Conservice Energy',
    'Discount Power',
    'Fort Belknap Electric Coop Inc',
    'Frontier Utilities',
    'GEUS Electric',
    'Karnes Electric Coop',
    'Mid-South Electric Coop',
    'Mojave Electric Cooperative',
    'Our Energy',
    'Panola-Harrison Electric Cooperative',
    'Payless Power',
    'San Bernard Electric Co-Op',
    'Source Power and Gas',
    'Spark Energy',
    'Texas Electric Service Company',
    'Veteran Energy',
    'Not Listed',
  ],
};

export default electricUtilities;
